import { render, staticRenderFns } from "./HomeBrokerButton.vue?vue&type=template&id=28338814&scoped=true&"
import script from "./HomeBrokerButton.vue?vue&type=script&lang=ts&"
export * from "./HomeBrokerButton.vue?vue&type=script&lang=ts&"
import style0 from "./HomeBrokerButton.vue?vue&type=style&index=0&id=28338814&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28338814",
  null
  
)

export default component.exports